//libary
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronCircleDown, faChevronCircleUp } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';

class Warring extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: true
        }
    }

    componentWillMount() {
        var data = {CId: 1};
        axios.post(process.env.REACT_APP_PCSERVER + "/cmsapi/Home/GetFooterContent", data, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
            .then((response) => {
                this.getFooterContent = response.data.Entries[0].CContent;
            }).catch((error) => {
            })
    }

    render() {
        return <div className="warringBlock">
            <div className="footer__warning">
                <div dangerouslySetInnerHTML={{__html: this.getFooterContent}}>
                </div>
                <div className="footer_bw">
                    <ul>
                        <li>
                        <p>本網站最佳瀏覽體驗建議使用Google Chrome、Edge、Safari，相關詳情請參閱「<a rel="noopener noreferrer" href="http://www.anuefund.com/new/customer/problem/%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97?item=1" target="_blank">瀏覽器建議設定</a>」。</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    }
    
}
export default Warring;